export default __webpack_public_path__ + "static/media/sticker-el.3b6f527b.png";